"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vacancy = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const BemloPlusIcon_1 = require("../../../svgs/BemloPlusIcon");
const translate_1 = require("../../../translate");
const create_styles_1 = require("../../../utils/create-styles");
const GREAT_MATCH_SCORE = 86;
const BemloPlus = styled_1.default.div((0, create_styles_1.createStyles)({
    backgroundColor: constants_1.Color.PURPLE,
    borderRadius: constants_1.theme.border.radius.normal,
    flexShrink: 0,
    height: '32px',
    p: 2,
    width: '32px',
}));
const VacancyElement = (0, styled_1.default)(elements_1.Div)((props) => ({
    ...(0, create_styles_1.createStyles)({
        alignItems: 'flex-start',
        cursor: 'pointer',
        flex: 'row',
        gap: 3,
        px: 3.5,
        py: 2.5,
        transition: constants_1.theme.animation.transition,
    }),
    '&:hover': {
        backgroundColor: props.compact ? constants_1.Color.LIGHTER_BLUE : constants_1.Color.LIGHTEST_BLUE,
    },
}));
const Vacancy = ({ compact, matchingVacancy, onClick, }) => {
    const { score, vacancy } = matchingVacancy;
    const t = (0, translate_1.useTranslations)();
    return ((0, jsx_runtime_1.jsxs)(VacancyElement, { compact: compact, onClick: () => onClick(matchingVacancy.vacancy), children: [(0, jsx_runtime_1.jsx)(BemloPlus, { children: (0, jsx_runtime_1.jsx)(BemloPlusIcon_1.BemloPlusIcon, { color: constants_1.Color.WHITE }) }), (0, jsx_runtime_1.jsxs)(elements_1.Flex, { col: true, gap: 1, grow: 1, children: [(0, jsx_runtime_1.jsxs)(elements_1.Flex, { justify: "between", children: [(0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 1, items: "center", wrap: true, children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, color: constants_1.Color.BLUE, mr: 2, size: compact ? 6.5 : 5.5, children: vacancy.title ?? `(${t.candidate_view.vacancies.no_title()})` }), score >= GREAT_MATCH_SCORE && ((0, jsx_runtime_1.jsx)(elements_1.Badge, { color: "green", size: "sm", children: t.candidate_view.vacancies.n_percent_match(score) }))] }), !compact && ((0, jsx_runtime_1.jsx)(elements_1.Text, { color: constants_1.Color.DARK_GREY, size: 6.5, styles: { userSelect: 'none' }, children: t.$date.unix(vacancy.createdAt).fromNow() }))] }), vacancy.unit && ((0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, size: 6.5, children: vacancy.unit.name })), (0, jsx_runtime_1.jsxs)(elements_1.Text, { color: constants_1.Color.DARK_GREY, size: 6.5, children: [vacancy.municipality && `${vacancy.municipality}, `, t.$whichRegionAlternative(vacancy.region)] }), vacancy.jobStartsAt && ((0, jsx_runtime_1.jsxs)(elements_1.Text, { color: constants_1.Color.DARK_GREY, size: 6.5, children: [t.$date.unix(vacancy.jobStartsAt).format('ll'), " \u2013", vacancy.jobEndsAt && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [" ", t.$date.unix(vacancy.jobEndsAt).format('ll')] }))] }))] })] }));
};
exports.Vacancy = Vacancy;
